import XLSX from "xlsx";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { DataGrid, GridColDef, GridSlotProps, GridToolbarContainer, } from "@mui/x-data-grid";
import { observer } from "mobx-react-lite";
import React from "react";
import { useParams } from "react-router-dom";
import CustomNoRowsOverlay from "../../../../ui/NoRowsOverlay";
import { ProjectInterface } from "../../../project/interfaces";
import projectStore from "../../../project/store";
import { BaseCalcRowItemInterface } from "../../schemas";
import filterStore from "../filters/filtersStore";


export interface BaseCalculationsTablePropsProps {
    rows: BaseCalcRowItemInterface[];
    loading: boolean;
}
interface CalculationsTableProps extends BaseCalculationsTablePropsProps {
    colDefs: GridColDef[];
    extraToolbar?: any;
    table: string;
}
const BaseResultTable = observer((props: CalculationsTableProps) => {
    let filteredRows = props.rows.filter((row: BaseCalcRowItemInterface) => row.sc_type === filterStore.getScType);
    if (filterStore.getSelectedNode) {
        filteredRows = filteredRows.filter((row: BaseCalcRowItemInterface) => row.sc_node_pk === filterStore.getSelectedNode);
    }

    return (
        <>
            <DataGrid
                sx={{minHeight: filteredRows.length > 0 ? 0 : "400px", width: "100%"}}
                rowHeight={30}
                columns={props.colDefs}
                rows={filteredRows}
                loading={props.loading}
                pageSizeOptions={[{value: -1, label: 'All'}]}
                slots={{
                    noRowsOverlay: CustomNoRowsOverlay,
                    toolbar: EditToolbar,
                }}
                slotProps={{
                    toolbar: {
                        extraToolbar: props.extraToolbar,
                        tableName: props.table,
                        data: filteredRows,
                        columns: props.colDefs.reduce(
                            (previousValue: any, currentValue: GridColDef) => {
                                previousValue[currentValue.field] = currentValue.field;
                                return previousValue;
                            },
                            {},
                        ),
                    } as GridSlotProps['toolbar'],
                }}
                hideFooter
            />
        </>
    );
});

export default BaseResultTable;


function EditToolbar(props: GridSlotProps['toolbar']) {
    // @ts-ignore
    const { extraToolbar, tableName, data } = props;

    const params = useParams();
    const currentProjectId = params.projectId ? +params.projectId : 0;
    const project: ProjectInterface | undefined = projectStore.getProjectById(currentProjectId);

    return (
        <GridToolbarContainer sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Box>
                <Button
                    variant="contained"
                    size="small"
                    sx={{ p: 0 }}
                    startIcon={<FileDownloadIcon />}
                    onClick={() => {
                        const worksheet = XLSX.utils.json_to_sheet(data);
                        const workbook = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(workbook, worksheet, tableName);
                        XLSX.writeFile(workbook, `${project?.title}_${tableName}_sc_type_${filterStore.getScType}_node_${filterStore.getSelectedNodeName}.xlsx`, { compression: true });
                    }}
                >
                    XLSX
                </Button>
            </Box>
            { Boolean(extraToolbar) && extraToolbar }
        </GridToolbarContainer>
    );
}
